export const headerKey = {
  CC_CORRELATION_ID: "cc-correlationid",
  CC_USER_ID: "cc-userid",
};